import { render } from "./form-container.vue?vue&type=template&id=863159ba&scoped=true"
import script from "./form-container.vue?vue&type=script&lang=js"
export * from "./form-container.vue?vue&type=script&lang=js"

import "./form-container.vue?vue&type=style&index=0&id=863159ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-863159ba"]])

export default __exports__